<p-panel
  *ngIf="job?.supplierId == supplierId || organisationTypeId == 1"
  styleClass="no-padding-panel overflow-hidden-panel panel-shadow"
>
  <p-header>
    <span class="panel-header">Carry-Over Authorisation</span>&nbsp;<i
      class="fa fa-info-circle"
      [escape]="false"
      pTooltip="A Carry-Over is where authorisation has been given<br>for a vehicle to be kept overnight between collection and delivery"
    ></i>
  </p-header>
  <div>
    <div style="max-height: 160px; overflow: auto">
      <p-table [value]="carryOverTasks" styleClass="no-border-table">
        <ng-template pTemplate="header">
          <tr>
            <th style="text-align: left">Vehicle</th>
            <th class="carryover-checks-col" *ngIf="organisationTypeId == 1">Checks</th>
            <th class="carryover-status-col">Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <ng-container *ngIf="typedTaskInfo(item) as data">
            <tr>
              <td class="carryover-vehicle-cell">
                <div class="flex align-items-center flex-wrap grid-gap-5 mb-1">
                  <span class="carry-over-vrm">{{ data.vehicle.registrationNumber }}</span>
                  <span *ngIf="data?.pausePhotos?.length == 0" style="opacity: 0.2">
                    <i class="fa fa-camera"></i>
                  </span>
                  <ng-container *ngFor="let pausePhoto of data.pausePhotos; let i = index">
                    <a
                      *ngIf="pausePhoto.photoLocation"
                      style="cursor: pointer"
                      (click)="openPhoto(data.pausePhotos, i)"
                    >
                      <i class="fa fa-camera"></i>
                    </a>
                  </ng-container>
                </div>
                <app-carryover-task-info [task]="data"></app-carryover-task-info>
              </td>
              <td class="carryover-checks-col" *ngIf="organisationTypeId == 1">
                <div class="text-center">
                  <span *ngIf="data.preApproveCarryover">
                    <div *ngIf="loadingConditions">
                      <i class="fa fa-spin fa-spinner"></i>
                    </div>
                    <div
                      *ngIf="!loadingConditions"
                      class="py-2 cursor-pointer"
                      (click)="opConditions.show($event)"
                    >
                      <div *ngIf="!data.preApproveCarryover?.preApproveCarryover">
                        <span
                          class="rejected-text"
                          *ngIf="missingConditions(data.preApproveCarryover) == 1"
                          >1 failed check</span
                        >
                        <span
                          class="rejected-text"
                          *ngIf="missingConditions(data.preApproveCarryover) > 1"
                          >{{ missingConditions(data.preApproveCarryover) }} failed checks</span
                        >
                      </div>
                      <div *ngIf="data.preApproveCarryover?.preApproveCarryover">
                        <span
                          class="accepted-text"
                          *ngIf="data.preApproveCarryover?.preApproveCarryover == true"
                          >All checks passed</span
                        >
                      </div>
                      <i class="fa fa-info-circle text-gray-600"></i>

                      <p-overlayPanel
                        #opConditions
                        appendTo="body"
                        [dismissable]="true"
                        [showCloseIcon]="true"
                      >
                        <app-carryover-approval-analysis
                          [carryOverTask]="item"
                        ></app-carryover-approval-analysis>
                      </p-overlayPanel>
                    </div>
                  </span>
                </div>
              </td>
              <td class="carryover-status-col">
                <!--Show pill for suppliers-->
                <app-carryover-approval-status-pill
                  *ngIf="organisationTypeId != 1"
                  [status]="data.carryoverApproval?.status"
                ></app-carryover-approval-status-pill>

                <!--Show dropdown for VME users-->
                <p-dropdown
                  *ngIf="organisationTypeId == 1"
                  [options]="CarryoverUtils.carryoverStatusOptions"
                  [ngModel]="data.carryoverApproval?.status ?? CarryoverApprovalStatus.Unset"
                  (onChange)="onStatusChange(data, $event)"
                  styleClass="carryover-status-dropdown cursor-pointer"
                  style="width: 100%"
                  appendTo="body"
                >
                  <ng-template let-selectedItem pTemplate="selectedItem">
                    <span
                      class="status-pill {{ CarryoverUtils.getStatusClass(selectedItem.value) }}"
                    >
                      {{ selectedItem.label }} <i class="fa fa-caret-down"></i>
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <span class="status-pill {{ CarryoverUtils.getStatusClass(option.value) }}">
                      {{ option.label }}
                    </span>
                  </ng-template>
                </p-dropdown>

                <div *ngIf="data.carryoverApproval" class="status-details">
                  <div class="status-meta">
                    <span
                      class="status-updated"
                      (mouseenter)="op.show($event)"
                      (mouseleave)="op.hide()"
                    >
                      Updated At: {{ data.carryoverApproval.dateUpdated | datex : 'HH:mm ddd Do' }}
                    </span>

                    <p-overlayPanel
                      #op
                      appendTo="body"
                      [dismissable]="true"
                      [showCloseIcon]="false"
                    >
                      <div class="status-details" style="max-width: 400px">
                        <div class="status-meta overflow-hidden">
                          By: {{ data.carryoverApproval.updatedByUserName || 'System' }}
                        </div>

                        <div *ngIf="data.carryoverApproval.reason" class="status-reason">
                          Reason: {{ data.carryoverApproval.reason }}
                        </div>
                      </div>
                    </p-overlayPanel>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-panel>

<p-dialog
  header="Change Approval Status"
  [(visible)]="showCarryOverDialog"
  [modal]="true"
  [style]="{ width: '600px', borderRadius: '12px' }"
  (onHide)="hideCarryOver()"
>
  <div class="flex gap-1 align-items-center">
    Changing status of vehicle
    <vehicle-reg>{{ carryOverTask?.vehicle?.registrationNumber }}</vehicle-reg> from
    <app-carryover-approval-status-pill [status]="carryOverTask?.carryoverApproval?.status">
    </app-carryover-approval-status-pill>
    to
    <app-carryover-approval-status-pill
      [status]="newCarryoverApprovalStatus"
    ></app-carryover-approval-status-pill>
  </div>

  <div class="my-2" *ngIf="carryOverTask?.carryoverAddress">
    <span *ngIf="carryOverTask?.isCarryoverAddressSupplierHome">
      The supplier has requested a home carryover.
    </span>
    <span *ngIf="!carryOverTask?.isCarryoverAddressSupplierHome">
      The supplier has requested a carryover at {{ carryOverTask?.carryoverAddress?.addressLine }}.
    </span>
  </div>

  <div
    *ngIf="
      newCarryoverApprovalStatus == CarryoverApprovalStatus.ManuallyApproved ||
      newCarryoverApprovalStatus == CarryoverApprovalStatus.Requested
    "
    class="mt-3"
  >
    <div style="font-weight: 500; margin-bottom: 5px">
      Select where the driver will be parked during carryover
    </div>
    <div>
      <input
        class="scaleRadio"
        id="driverAddress"
        type="radio"
        name="carryOverLocation"
        [value]="CarryoverLocation.SupplierHome"
        [(ngModel)]="carryOverLocation"
        required
      />
      <label for="driverAddress">Driver's home</label>
      address
    </div>
    <div>
      <input
        class="scaleRadio"
        id="otherAddress"
        type="radio"
        name="carryOverLocation"
        [value]="CarryoverLocation.Other"
        [(ngModel)]="carryOverLocation"
        required
      />
      <label for="otherAddress">Other</label>
    </div>

    <div *ngIf="carryOverLocation == CarryoverLocation.Other" class="mt-2">
      <textarea
        class="p-2"
        pInputTextarea
        [(ngModel)]="carryOverComment"
        placeholder="Please specify location..."
        style="
          width: 100%;
          height: 50px;
          border: 1.5px solid var(--container-border-color) !important;
          border-radius: 5px;
        "
      ></textarea>
    </div>
  </div>

  <div class="mt-3">
    <div style="font-weight: 500; margin-bottom: 5px">Reason for status change (optional)</div>

    <div class="mt-2">
      <textarea
        class="p-2"
        pInputTextarea
        [(ngModel)]="carryoverStatusChangeReason"
        placeholder="Enter reason for status change..."
        style="width: 100%; height: 50px; border-radius: 5px"
      ></textarea>
    </div>
  </div>

  <p-footer>
    <div class="text-right">
      <button
        pButton
        label="Cancel"
        (click)="cancelCarryOver()"
        class="ui-button ui-button-tertiary"
      ></button>
      <p-button
        label="Change Status"
        (click)="changeCarryoverApprovalStatus()"
        [disabled]="!canSaveCarryOver()"
      ></p-button>
    </div>
  </p-footer>
</p-dialog>

<p-blockUI [blocked]="loadingPopupPhoto || isShownPopupPhoto">
  <img
    *ngIf="loadingPopupPhoto"
    src="assets/images/loader.gif"
    style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%)"
    width="50"
    height="50"
    alt="load"
  />
</p-blockUI>
<img
  *ngIf="isShownPopupPhoto"
  [src]="popupPhotoUrl"
  style="
    z-index: 10000;
    max-height: 90%;
    max-width: 90%;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  "
/>

<ngx-gallery
  *ngIf="showImage"
  [options]="overnightGalleryOptions"
  [images]="overnightImages"
  (previewClose)="onOverNightImagePreviewClose()"
></ngx-gallery>
